import {Col, Modal, Row} from 'antd'
import {FacebookOutlined, HomeOutlined, InstagramOutlined, MailOutlined, PhoneOutlined, UserOutlined} from '@ant-design/icons'
import GParallax from '../helpers/GParallax'
import {$app, $t, _$t} from '../../app'
import {useEffect, useState} from 'react'
import {$language} from '../../app/Languages'
import {ButtonLinkLike} from '../buttons/ButtonLinkLike'
import {Link} from 'react-router-dom'

export function Footer() {
  let contents = {}
  const [companyEmail, setCompanyEmail] = useState('')



  useEffect(() => {
    (async () => {

      setCompanyEmail(await _$t("footer_contact_email"))

    })()
  })


  return (
    <>
      <div className="footer-cordinates"><a href="https://maps.app.goo.gl/ykddfkVx9rptoVMh6" target="_blank" rel="noreferrer">63° 50' 11.0" N<br/>21° 03' 52.3" W</a></div>

      <footer>

        <div className="footer-content">

          <Row className="container wide centered mb-4" align="center" >
            <Col md={6} lg={6} sm={12} xs={12}>
              <h4><$t _="footer_socials"/></h4>
              <ul>
                <li className="mb-1 va-middle"><InstagramOutlined className="h5"/>@trailsoficeandfire</li>
                <li className="mb-1 va-middle"><FacebookOutlined className="h5"/>Trails of Ice and Fire</li>
              </ul>
            </Col>
            <Col md={6} lg={6} sm={12} xs={12}>
              <h4><$t _="footer_contact"/></h4>
              <ul>
                <li className="mb-1 va-middle"><PhoneOutlined className="h5"/><$t _="footer_contact_phone_number"/></li>
                <li className="mb-1 va-middle"><a href={`mailto:${companyEmail}`}> <MailOutlined className="h5"/><$t _="footer_contact_email"/></a></li>
              </ul>
            </Col>
            <Col md={6} lg={6} sm={12} xs={12}>
              <h4><$t _="footer_location"/></h4>
              <ul>
                <li className="mb-1 va-middle"><a href="https://maps.app.goo.gl/5DFaKFVQKpGbuofV8" target="_blank" rel="noreferrer"><HomeOutlined className="h5"/><$t _="footer_location_text1"/></a></li>
                <li className="mb-1 va-middle"><UserOutlined className="h5"/><$t _="footer_location_text2"/></li>
              </ul>
            </Col>
            <Col md={6} lg={6} sm={12} xs={12}>
              <h4><$t _="footer_legals"/></h4>
              <ul>
                <li className="mb-1 va-middle"><Link to="/vop"><$t _="footer_leglas_vop"/></Link></li>
                <li className="mb-1 va-middle"><Link to="/data-protection"><$t _="footer_leglas_gdpr"/></Link></li>
              </ul>
            </Col>
          </Row>

          <p className="ta-center">
            <$t _="footer_all_rights_reserved"/> &nbsp; &nbsp; &nbsp;
            Created by <a href="https://www.jakubpexa.cz" target="_blank">www.jakubpexa.cz</a>
          </p>

        </div>
      </footer>
    </>
  )
}